import { ObjectMapper } from 'json-object-mapper';
import { IModel } from 'services/models/IModel';
import { Model } from 'services/models/model';

export class CompanyFacilityModel extends Model implements IModel<CompanyFacilityModel> {
  public companyId: string = '';
  public companyGroupId: string = '';
  public name: string = '';
  public companyName: string = '';
  public fullName: string = '';

  static create(input: any): CompanyFacilityModel {
    return ObjectMapper.deserialize<CompanyFacilityModel>(CompanyFacilityModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
